import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRulePreference.errors.";

const medicalSpecialtySchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "medical_specialty" },
);

const calendarPreferencesSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const preferencesSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  medicalSpecialty: medicalSpecialtySchema,
  calendarPreferences: z.array(calendarPreferencesSchema).nullish(),
});

export type TPreferencesForm = z.infer<typeof preferencesSchema>;
